/* ==========================================================================
   AutocompleteRxjs > Client > Suggestions > Keyboard
   ========================================================================== */

/* Modules */
const { fromEvent } = require('rxjs');
const { tap, filter } = require('rxjs/operators');

const { getNextSibling, getPreviousSibling } = require('../../../../../helpers/dom');

const configuration = require('../config');

const { SUGGESTIONS_KEYS, KEY_ARROW_UP, KEY_ARROW_DOWN, KEY_ENTER, KEY_ESC, KEY_TAB } = require('../../../constants');

/* Helpers */
const goToFirstEl = instance => {
    const panel = instance;

    /* Hooks */
    const { list } = instance.hooks;

    /* Els */
    panel.hooks.keyedEl = list.querySelector('[data-autocomplete-suggestion]');
    instance.hooks.keyedEl.classList.add(configuration().css.keyed);
    instance.hooks.keyedEl.scrollIntoView();
};

const goToLastEl = instance => {
    const panel = instance;

    /* Hooks */
    const { list } = instance.hooks;

    /* Els */
    panel.hooks.keyedEl = [...list.querySelectorAll('[data-autocomplete-suggestion]')].pop();
    instance.hooks.keyedEl.classList.add(configuration().css.keyed);
    instance.hooks.keyedEl.scrollIntoView();
};

const goToNextEl = (element, instance) => {
    const panel = instance;

    if (!element) {
        goToFirstEl(instance);

        return;
    }

    element.classList.remove(configuration().css.keyed);
    panel.hooks.keyedEl = getNextSibling(element, '[data-autocomplete-suggestion]');

    if (!instance.hooks.keyedEl) {
        goToFirstEl(instance);

        return;
    }

    instance.hooks.keyedEl.classList.add(configuration().css.keyed);
    instance.hooks.keyedEl.scrollIntoView();
};

const goToPreviousEl = (element, instance) => {
    const panel = instance;

    if (!element) {
        goToLastEl(instance);

        return;
    }

    element.classList.remove(configuration().css.keyed);
    panel.hooks.keyedEl = getPreviousSibling(element, '[data-autocomplete-suggestion]');

    if (!instance.hooks.keyedEl) {
        goToLastEl(instance);

        return;
    }

    instance.hooks.keyedEl.classList.add(configuration().css.keyed);
    instance.hooks.keyedEl.scrollIntoView();
};

const handleTab = instance => {
    const { suggestions } = instance.store.select('autocomplete');
    const { keyedEl } = instance.hooks;

    if (!keyedEl) {
        /* Change value to the first one */
        instance.actions.changeValue(suggestions[0]);

        return;
    }

    /* Change value to the keyed one */
    instance.actions.changeValue(suggestions[+keyedEl.dataset.autocompleteSuggestion]);
};

const handleEnter = instance => {
    const { suggestions } = instance.store.select('autocomplete');
    const { keyedEl } = instance.hooks;

    if (!keyedEl) {
        return;
    }

    /* Change value to the keyed one */
    instance.actions.changeValue(suggestions[+keyedEl.dataset.autocompleteSuggestion]);
};

/* Init */
function initKeyboard(instance) {
    const panel = instance;

    /* Hooks */
    panel.hooks = {
        ...instance.hooks,
        keyedEl: null
    };

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        keydowns: fromEvent(instance.hooks.input, 'keydown')
            .pipe(
                tap(event => event.stopPropagation()),
                filter(event => SUGGESTIONS_KEYS.includes(event.keyCode)),
                filter(() => instance.store.select('autocomplete').openSuggestions)
            )
            .subscribe(event => {
                event.preventDefault();
                const { keyCode } = event;
                const { keyedEl } = instance.hooks;

                switch (keyCode) {
                    case KEY_ESC:
                        instance.hooks.input.blur();
                        /* Close suggestions and sync input value */
                        instance.actions.closeSuggestions();
                        instance.actions.syncValue();

                        break;
                    case KEY_ARROW_DOWN:
                        goToNextEl(keyedEl, instance);
                        break;
                    case KEY_ARROW_UP:
                        goToPreviousEl(keyedEl, instance);
                        break;
                    case KEY_ENTER:
                        handleEnter(instance);
                        break;
                    case KEY_TAB:
                        handleTab(instance);
                        break;
                    default:
                        break;
                }
            })
    };
}

/* Destroy */
function destroyKeyboard(instance) {
    const panel = instance;

    /* Hooks */
    panel.hooks.keyedEl = null;

    /* Subscriptions */
    instance.subscriptions.keydowns.unsubscribe();
    delete panel.subscriptions.keydowns;
}

/* Exports */
module.exports = {
    initKeyboard,
    destroyKeyboard
};
